import { render, staticRenderFns } from "./BUCPCFAA.vue?vue&type=template&id=8b186800&scoped=true&"
import script from "./BUCPCFAA.vue?vue&type=script&lang=js&"
export * from "./BUCPCFAA.vue?vue&type=script&lang=js&"
import style0 from "./BUCPCFAA.vue?vue&type=style&index=0&id=8b186800&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b186800",
  null
  
)

export default component.exports